import React from 'react';
import Footer from '../Footer';
import './CRV.css';
import { useEffect } from 'react';

function SoftwareDownloadV () {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    const webAppUrl = 'https://script.google.com/macros/s/AKfycbztN5hdWl4dFciykhhxId4bpBzYFpPz35KtWD6a-MDg4DLsIFgGqT2TP1aDpEBGpsiXZA/exec';

    return (
        <div>
            <section>
            <div className="content holds-the-iframe">
            <iframe className='frame' src="https://script.google.com/macros/s/AKfycbwHi0LpbFiGf6YiNswWk0lMZ-NCMrNPmoh3BMgeKO_TM15gnt4nV5eCVrLxRAoMwdnFtg/exec" title="Google Apps Script" width="100%" height="500px"></iframe>
                {/* <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossorigin="anonymous"></script> */}
            </div>
            <div class='air air1'></div>
            <div class='air air2'></div>
            <div class='air air3'></div>
            <div class='air air4'></div>
            </section>

            <Footer/>
        </div>
    );
}

export default SoftwareDownloadV;
